'use client';

import { useEffect, useState } from 'react';
import CookieDrawer from './cookie-drawer';
import { ENDPOINTS } from '@/app/lib/constants/endpoints';
import { usePathname, useRouter } from 'next/navigation';
import { APP_URLS } from '@/app/lib/constants/app-urls';
import { hasCookie } from 'cookies-next/client';
import { ANALYTICS_CONSENT } from '@/app/lib/constants/cookie-values';
import { configEndpoint } from '@/app/lib/utils/api-utils';
import { setAnalyticsConsent } from '@/app/lib/store/analytics-consent-slice';
import { useAppDispatch } from '@/app/lib/store/hooks';

const CookieDrawerContainer = () => {
  const pathname = usePathname();
  const router = useRouter();
  const [drawerPortal, setDrawerPortal] = useState<HTMLElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [render, setRender] = useState(false); // определяет, нужно ли рендерить в зависимости от наличия согласия
  const [isLegalDocPage, setIsLegalDocPage] = useState(false); // не отображать на странице Политики конфиденциальности и Условий использования
  const [cookieText, setCookieText] = useState('');

  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchText = async () => {
      const endpoint = configEndpoint(ENDPOINTS.cookieText);

      const response = await fetch(endpoint);
      if (response.ok) {
        const data = await response.json();
        const { markdown } = data;

        setCookieText(markdown);
        setRender(!isLegalDocPage);
        setIsOpen(!isLegalDocPage);
      } else {
        // Обработка ошибок
        console.error('Ошибка при получении данных');
      }
    };

    const hasConsented = hasCookie('analytics-consent');
    if (!hasConsented) {
      fetchText();
    }
  }, [isLegalDocPage]);

  useEffect(() => {
    setIsLegalDocPage(
      [APP_URLS.privacyPolicy, APP_URLS.terms].includes(pathname)
    );
  }, [pathname]);

  useEffect(() => {
    setDrawerPortal(document.getElementById('cookie-drawer-portal'));
  }, []);

  // const setConsent = async (value: 'accepted' | 'rejected') => {
  const setConsent = async (value: ANALYTICS_CONSENT) => {
    const endpoint = new URL(
      ENDPOINTS.cookieConsent,
      process.env.NEXT_PUBLIC_BASE_URL
    ).toString();
    await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ consent: value })
    });
    dispatch(setAnalyticsConsent(value === ANALYTICS_CONSENT.ACCEPTED));
    setIsOpen(false);

    if (value === ANALYTICS_CONSENT.ACCEPTED) {
      router.refresh();
    }
  };

  return (
    <CookieDrawer
      render={render}
      drawerPortal={drawerPortal}
      isOpen={isOpen}
      setConsent={setConsent}
      markdown={cookieText}
    />
  );
};

export default CookieDrawerContainer;
